// models/ViolationType.js
export default class ViolationType {
    constructor({
        violationTypeId = 0,
        name = "",
        isActive = false,
    } = {}) {
        this.violationTypeId = violationTypeId;
        this.name = name;
        this.isActive = isActive;
    }
}